import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { LanguageModule } from '@language';
import {
    ShActionItemComponent,
    ShClickOutsideDirective,
    ShFormGroupComponent,
    ShHtmlParserComponent,
    ShIconModule
} from '@stylehaven/components';
import { SharedDialogModule } from '../dialog/dialog.module';
import { ThesaurusModule } from '../thesaurus/thesaurus.module';
import { FormThesaurusComplexBaseComponent } from './base-complex/form-thesaurus-base-complex.component';
import { FormThesaurusBaseComponent } from './base-simple/form-thesaurus-base.component';
import { FormThesaurusComponent } from './main/form-thesaurus.component';

@NgModule({
    declarations: [FormThesaurusComponent, FormThesaurusBaseComponent, FormThesaurusComplexBaseComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ShActionItemComponent,
        ShIconModule,
        LanguageModule,
        SharedDialogModule,
        ThesaurusModule,
        ShClickOutsideDirective,
        ShHtmlParserComponent,
        ShFormGroupComponent
    ],
    exports: [FormThesaurusComponent, FormThesaurusBaseComponent, FormThesaurusComplexBaseComponent],
    providers: []
})
export class FormThesaurusModule {}

export { FormThesaurusComplexBaseComponent } from './base-complex/form-thesaurus-base-complex.component';
export { FormThesaurusBaseComponent } from './base-simple/form-thesaurus-base.component';
export { FormThesaurusComponent } from './main/form-thesaurus.component';
